class Controller {
  $onInit() {
    this.result = this.exact / this.max;
    this.resultInPercentage = (this.result * 100).toFixed(0);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/progressIndicator/progressIndicator.controller.js